import { ChecklistActions } from "../action-types/checklistActionTypes";

// Checklist Action

export const getChecklistList = (payload) => {
  return {
    type: ChecklistActions.GET_CHECKLIST_LIST,
    payload,
  };
};

export const setChecklistList = (payload) => {
  return {
    type: ChecklistActions.SET_CHECKLIST_LIST,
    payload,
  };
};

export const setChecklistpagination = (payload) => {
  return {
    type: ChecklistActions.SET_CHECKLIST_LIST_PAGINATION,
    payload,
  };
};

export const getChecklistQuestionAnswerList = (payload) => {
  return {
    type: ChecklistActions.GET_CHECKLIST_QUESTION_ANSWER_LIST,
    payload,
  };
};

export const setChecklistQuestionAnswerList = (payload) => {
  return {
    type: ChecklistActions.SET_CHECKLIST_QUESTION_ANSWER_LIST,
    payload,
  };
};

export const deleteItem = (itemId) => ({
  type: ChecklistActions.DELETE_CHECKLIST_QUESTION,
  payload: { itemId },
});
export const getChecklistDefectsList = (payload) => {
  return {
    type: ChecklistActions.GET_CHECKLIST_DEFECTS_LIST,
    payload,
  };
};

export const setChecklistDefectsList = (payload) => {
  return {
    type: ChecklistActions.SET_CHECKLIST_DEFECTS_LIST,
    payload,
  };
};
